import { PrismicRichTextField } from "@www/graphql-types";

import { CostTableData, CostTab, CostTBody } from "./CostBreakdown.types";

function getText(field: PrismicRichTextField): string {
  return field.text || "";
}

export function transformData(input: CostTableData | null): CostTab[] | null {
  if (!input || !input.slices.length) {
    return null;
  }

  const headers = input.headers.map(field =>
    getText(field),
  ) as CostTab["headers"];
  const data: CostTab[] = [];

  input.labels.map(label => {
    const id = label.cost_breakdown_slide_id;
    const groups: CostTBody[] = input.slices
      .filter(slice => slice.primary.cost_breakdown_group_slide_id === id)
      .map(({ primary, items }): CostTBody => {
        return {
          order: primary.cost_breakdown_group_order || 9999,
          headers: [
            getText(primary.cost_breakdown_group_title),
            getText(primary.cost_breakdown_group_percentage),
            getText(primary.cost_breakdown_group_cost),
          ],
          rows: items.map(item => ({
            heading: getText(item.cost_breakdown_row_heading),
            details: getText(item.cost_breakdown_row_details),
            value: getText(item.cost_breakdown_row_cost),
          })),
        };
      })
      .sort((a, b) => a.order - b.order);

    data.push({
      id,
      headers,
      groups,
      label: getText(label.cost_breakdown_slide_name),
    });
  });

  return data;
}
